'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'bullseye-pointer';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f649';
var svgPathData = 'M448 256c0 106-86 192-192 192-2.4 0-4.8 0-7.2-.1l-12.1 36.4c-3.4 10.3-8.9 18.8-15.6 25.4 11.4 1.6 23 2.4 34.9 2.4 141.4 0 256-114.6 256-256S397.4 0 256 0 0 114.6 0 256c0 11.8 .8 23.5 2.4 34.9 6.6-6.7 15.1-12.1 25.4-15.6l36.4-12.1c-.1-2.4-.1-4.8-.1-7.2 0-106 86-192 192-192s192 86 192 192zm-48 0c0-79.5-64.5-144-144-144-76.5 0-139.1 59.7-143.7 135.1l70.6-23.5c12.4-28 40.5-47.6 73.2-47.6 44.2 0 80 35.8 80 80 0 32.6-19.6 60.7-47.6 73.2l-23.5 70.6C340.3 395.1 400 332.5 400 256zM255.2 277.1c1.9-5.8 .4-12.1-3.9-16.4s-10.6-5.8-16.4-3.9l-192 64C36.4 323 32 329.1 32 336s4.4 13 10.9 15.2l63 21-90.9 90.9c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l90.9-90.9 21 63c2.2 6.5 8.3 10.9 15.2 10.9s13-4.4 15.2-10.9l64-192z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBullseyePointer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;